function delay(timeMs: number) {
  return new Promise((resolve) => setTimeout(resolve, timeMs));
}

/**
 * Factory for creating a local host API. This factory delays the result to
 * simulate an API call and wraps the API result within a promise.
 *
 * @param api The API definition.
 * @param delayMs Delay to simulate a real API call in ms.
 * @returns The result returned by the API wrapped in a promise.
 */
export function createLocalHostApiFactory<T>(
  api: (...args: unknown[]) => T,
  delayMs = 1000
): (...args: unknown[]) => Promise<T> {
  return async (...args: unknown[]) => {
    await delay(delayMs);

    return new Promise((resolve, reject) => {
      try {
        resolve(api(...args));
      } catch (e) {
        reject(e);
      }
    });
  };
}
